import React, { useState, useEffect } from 'react'
import { MuiThemeProvider, makeStyles, useTheme } from '@material-ui/core/styles'
import { useHistory, useParams } from 'react-router-dom'
import { getChipStyles } from '../../services/helpers'
import { Typography, Button, IconButton, Chip, Link } from '@material-ui/core'

import { Link as RouterLink } from 'react-router-dom'

import { KeyboardDatePicker } from '@material-ui/pickers'

import MaterialTable, { MTableCell, MTableToolbar } from '@material-table/core'
import { table } from '../../services/theme'

import moment from 'moment'
import clsx from 'clsx'
import { useSelector } from 'react-redux'
import MemberActivityDialog from '../Dialogs/Membership/MemberActivityDialog'

const useStyles = makeStyles((theme) => ({
	headerButton: {
		fontFamily: 'Nunito',
		fontWeight: '700',
		'& .MuiButton-label': {
			lineHeight: '19px',
			fontSize: '14px'
		}
	},
	addClientButton: {
		color: theme.palette.secondary.main,
		borderColor: theme.palette.secondary.main,
		padding: '7px 40px 8px 24px',
		'& .MuiButton-label': {
			'& .MuiButton-startIcon': {
				marginRight: 16
			}
		}
	},
	toolbarWrapper: {
		display: 'flex',
		flexDirection: 'column',
		backgroundColor: '#F9F9F9'
	},
	petStatusIcon: {
		position: 'absolute',
		left: 0
	},
	toolbarExtras: {
		display: 'flex',
		'& > *': {
			marginRight: '16px'
		}
	},
	toolbar: {
		display: 'flex',
		alignItems: 'center',
		flexWrap: 'wrap',
		padding: '24px 25px',
		'& > div:nth-child(1)': {
			'& > div:nth-child(4)': {
				flex: 'auto'
			}
		}
	},
	datePickerContainer: {
		display: 'flex',
		alignItems: 'center',
		position: 'relative'
	},
	datePicker: {
		color: '#FFFFFF',
		opacity: 0,
		position: 'absolute',
		top: 0,
		height: 38,
		margin: 0,
		'& *': {
			height: 0,
			padding: 0,
			margin: 0
		}
	},
	calendarButton: {
		'& svg': {
			fill: theme.palette.primary.main
		}
	},
	calendarHeaderButtons: {
		fill: theme.palette.primary.main
	},
	calendarDateButton: {
		zIndex: 1,
		border: '1px solid #D0CFD2',
		padding: '7px 16px 8px 24px',
		color: '#4D4C4F',
		fontWeight: '700',
		'& .MuiButton-label': {
			'& .MuiButton-endIcon': {
				marginLeft: 16
			},
			whiteSpace: 'nowrap'
		}
	},
	dateChangeButton: {
		border: '1px solid #D0CFD2',
		height: 38,
		width: 38,
		padding: 5,
		'& svg': {
			height: 16
		}
	},
	addAppointmentButton: {
		color: theme.palette.secondary.main,
		borderColor: theme.palette.secondary.main,
		padding: '7px 40px 8px 24px',
		'& .MuiButton-label': {
			'& .MuiButton-startIcon': {
				marginRight: 16
			}
		}
	},
	scheduleAggregatesWrapper: {
		display: 'flex',
		flexWrap: 'wrap',
		paddingTop: '10px',
		paddingBottom: '12px'
	},
	scheduleAggregate: {
		padding: '4px 16px',
		border: '1px solid #D0CFD2',
		borderRadius: 6,
		color: '#4D4C4F',
		cursor: 'pointer',
		marginRight: 16,
		marginTop: 5,
		marginBottom: 5,
		'&:hover': {
			color: theme.palette.secondary.main,
			borderColor: theme.palette.secondary.main
		},
		'&.active': {
			color: '#FFFFFF',
			backgroundColor: theme.palette.secondary.main
		},
		'&:nth-child(1)': {
			marginLeft: 0
		}
	},
	spacer: {
		margin: '5px 16px 5px 0px',
		width: '24px',
		position: 'relative',
		'&:before': {
			content: "''",
			position: 'absolute',
			height: '1px',
			width: '100%',
			top: 'calc(50% - 1px)',
			left: 0,
			backgroundColor: '#F3F3F3'
		}
	}
}))

export const CheckInsTable = (props) => {
	const classes = useStyles()

	const [checkInShown, setCheckInShown] = useState(false)
	const [selectedCheckIn, setSelectedCheckIn] = useState({})

	const facilities = useSelector((state) => state.specific.facilities.facilities)
	const household = useSelector((state) => state.specific.households.selected)

	const accounts = household?.accounts ? household.accounts : []

	const renderDescription = (data) => (
		<Typography variant="body2" style={{ fontWeight: '600', color: '#6B4AD6', fontSize: '16px' }}>
			{data.time_checked_in ? data.time_checked_in : moment(data.createdAt).format('MMMM Do, YYYY, h:mm a')}
		</Typography>
	)

	const renderEntryMethod = (data) => {
		if (!data.checked_in) return 'N/A'

		if (data.access_method) {
			let accessMethod = data.access_method
			let splitAccessMethod = accessMethod.split(' ')

			if (
				splitAccessMethod &&
				splitAccessMethod.length > 1 &&
				splitAccessMethod[splitAccessMethod.length - 1] === 'Member'
			) {
				splitAccessMethod.pop()
				splitAccessMethod.push('membership')
				accessMethod = splitAccessMethod.join(' ')
			}

			return accessMethod
		} else return 'N/A'
	}

	const renderFacility = (data) => {
		if (data.facility_id) {
			let facility = facilities.find((facility) => data.facility_id == facility._id)

			return facility.name
		}

		return 'No Facility'
	}

	const renderStatus = (data) => {
		if (data.checked_in) {
			if (data.expired) {
				return <Chip label={'Complete'} />
			}
			return <Chip label={'Checked In'} style={getChipStyles('checked in')} />
		} else {
			if (!data.checked_in) {
				if (data.cancelled) {
					return <Chip label={'Cancelled'} style={getChipStyles('cancelled')} />
				} else if (data.expired) {
					return <Chip label={'Expired'} style={getChipStyles('warning')} />
				} else {
					return <Chip label={'Waiting'} />
				}
			}
		}
	}

	const getSelected = () => {
		if (!selectedCheckIn || !props.checkIns) return null
		let ours = props.checkIns.find((c) => c._id === selectedCheckIn)
		return ours
	}

	return (
		<MuiThemeProvider theme={table}>
			<MaterialTable
				scheduleAggregates={props.scheduleAggregates}
				date={props.date}
				options={{
					headerStyle: {
						color: '#1A1A35',
						textTransform: 'uppercase',
						fontWeight: 800,
						fontSize: '12px',
						lineHeight: '16px',
						padding: '11px 24px',
						borderTop: '1px solid #D0CFD2',
						backgroundColor: '#F9F9F9'
					},
					rowStyle: {
						verticalAlign: 'top'
					},
					pageSize: 10,
					pageSizeOptions: [10, 20, 50],
					toolbar: false
				}}
				columns={[
					{
						title: 'Description',
						render: (data) => renderDescription(data, classes)
					},
					{
						title: 'Entry Method',
						field: 'type',
						cellStyle: { textTransform: 'capitalize' },
						render: (data) => renderEntryMethod(data)
					},
					{
						title: 'Facility',
						render: (data) => renderFacility(data)
					},
					{
						title: 'Status',
						field: 'status.name',
						render: (data) => renderStatus(data)
					}
				]}
				data={props.checkIns || []}
				onRowClick={(e, checkin) => {
					setSelectedCheckIn(checkin._id)
					setCheckInShown(true)
				}}
				components={{
					Cell: (props) => (
						<MTableCell
							style={{
								borderBottom: 'none',
								padding: '16px 36px 16px 24px'
							}}
							{...props}
						/>
					)
				}}
			/>
			<MemberActivityDialog isShown={checkInShown} setIsShown={setCheckInShown} checkIn={getSelected()} accounts={accounts}/>
		</MuiThemeProvider>
	)
}
